import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import attendanceService from '@/services/attendanceService'

const initialState = {
  records: [],
  todayRecord: null,
  locations: [],
  loading: false,
  error: null,
  pagination: {
    total: 0,
    page: 1,
    perPage: 20,
    totalPages: 0,
  },
}

// Async thunks
export const checkIn = createAsyncThunk(
  'attendance/checkIn',
  async (data, { rejectWithValue }) => {
    try {
      const response = await attendanceService.checkIn(data)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Check-in failed')
    }
  }
)

export const checkOut = createAsyncThunk(
  'attendance/checkOut',
  async (data, { rejectWithValue }) => {
    try {
      const response = await attendanceService.checkOut(data)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Check-out failed')
    }
  }
)

export const fetchRecords = createAsyncThunk(
  'attendance/fetchRecords',
  async (params, { rejectWithValue }) => {
    try {
      const response = await attendanceService.getRecords(params)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch records')
    }
  }
)

export const fetchLocations = createAsyncThunk(
  'attendance/fetchLocations',
  async (_, { rejectWithValue }) => {
    try {
      const response = await attendanceService.getLocations()
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch locations')
    }
  }
)

const attendanceSlice = createSlice({
  name: 'attendance',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      // Check In
      .addCase(checkIn.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(checkIn.fulfilled, (state, action) => {
        state.loading = false
        state.todayRecord = action.payload.data
      })
      .addCase(checkIn.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      // Check Out
      .addCase(checkOut.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(checkOut.fulfilled, (state, action) => {
        state.loading = false
        state.todayRecord = action.payload.data
      })
      .addCase(checkOut.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      // Fetch Records
      .addCase(fetchRecords.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchRecords.fulfilled, (state, action) => {
        state.loading = false
        state.records = action.payload.data.items
        state.pagination = action.payload.data.pagination
      })
      .addCase(fetchRecords.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      // Fetch Locations
      .addCase(fetchLocations.fulfilled, (state, action) => {
        state.locations = action.payload.data
      })
  },
})

export const { clearError } = attendanceSlice.actions
export default attendanceSlice.reducer
